import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const CategoriesList = Loadable(
  lazy(() => import("src/pages/user/categoriesList"))
);
const ModuleView = Loadable(
  lazy(() => import("src/pages/user/onlineStore/moduleviews/index"))
);
const VideoTraining = Loadable(
  lazy(() => import("src/pages/user/subscriptionVdo/index"))
);

const subscriptionVdoEng = {
  path: "subscriptionEng",
  children: [
    {
      index: true,
      element: <Navigate to="categories" replace />,
    },

    {
      path: "categories",
      children: [
        {
          index: true,
          element: <CategoriesList lang="en" title="Categories" />,
        },
        {
          path: ":category_id",
          element: <ModuleView lang="en" />,
        },
        {
          path: ":category_id/modules/:id",
          element: <VideoTraining lang="en" />,
        },
      ],
    },
  ],
};

export default subscriptionVdoEng;
